import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NGXLogger } from 'ngx-logger';
import { catchError, map, Observable, of, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HkAmlPolicypAck } from './aml-policy-ack.model';
import { showErrorDialog, showSuccessSnackbar } from 'src/app/shared/utils';

@Injectable({
  providedIn: 'root'
})
export class HkAmlPolicyAcksService {
  private apiEndpoint = `${environment.apiEndpoint}/api/hk/aml-policy-acks`;

  constructor(
    private http: HttpClient,
    private logger: NGXLogger,
    public apiErrorDialog: MatDialog,
    private snackBar: MatSnackBar
  ) {}

  public getMine$(): Observable<HkAmlPolicypAck | null> {
    return this.http.get<HkAmlPolicypAck>(`${this.apiEndpoint}/me`).pipe(catchError(() => of(null)));
  }

  public acknowledge$(readingTimeMs: number): Observable<void> {
    return this.http
      .post(`${this.apiEndpoint}/ack`, null, {
        params: {
          readingTimeMs: readingTimeMs.toString()
        },
        responseType: 'text'
      })
      .pipe(
        map(() => showSuccessSnackbar(this.snackBar, 'Your acknowledgement was successfully recorded')),
        catchError((error: any) => {
          this.logger.error(error);
          showErrorDialog(this.apiErrorDialog, error);
          return throwError(() => new Error(error));
        })
      );
  }
}
